import React from 'react';
import { twoDigits } from '../helpers/Utils';
import cxs from 'cxs/component';
import theme from '../Theme';
const HoursSelect = ({ lista, listaEnabled, itemSelected, onChange, onError }) => {
    return (React.createElement("div", { style: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center'
        } }, lista && lista.map((item) => {
        const selected = item.id === itemSelected;
        const disabled = !listaEnabled.find(itemDisabled => itemDisabled.id === item.id);
        if (selected && disabled && onError) {
            onError(item);
        }
        return (React.createElement(Wrapper, { key: item.id, style: {
                borderRadius: 10,
            }, selected: selected, disabled: disabled, onClick: () => { if (!disabled)
                onChange(item); } }, twoDigits(item.hours) + ':' + twoDigits(item.minutes)));
    })));
};
export default HoursSelect;
const Wrapper = cxs('div')(({ selected, disabled }) => ({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: disabled ? 'white' : selected ? 'green' : 'black',
    padding: '8px',
    margin: '5px 2px',
    backgroundColor: disabled ? 'red' : selected ? 'green' : undefined,
    color: disabled && selected ? 'green' : disabled || selected ? 'white' : undefined,
    ':hover': {
        borderColor: disabled ? undefined : selected ? 'white' : theme.color.primary,
        color: selected || disabled ? undefined : theme.color.primary,
        borderWidth: selected || disabled ? undefined : '2px',
        padding: selected || disabled ? undefined : '7px',
        cursor: selected || disabled ? undefined : 'pointer'
    }
}));



//////////////////
// WEBPACK FOOTER
// ./src/components/HoursSelect.tsx
// module id = 558
// module chunks = 0